import React from "react";
import {
  JobEntityType,
  JobEntityTypeColors,
} from "../../models/Jobs/JobEntityType";
import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "../ui/alert";
import { Badge } from "../ui/badge";
import ConfirmationModal from "../common/ConfirmationModal";

interface ConfirmMigrationEntitiesDeletionConfig {
  title: string;
  jobEntityType: JobEntityType;
}

interface ConfirmMigrationEntitiesDeletionModalProps {
  open: boolean;
  entityKeys: string[];
  confirmMigrationDeletionConfig: ConfirmMigrationEntitiesDeletionConfig;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmMigrationEntitiesDeletionModal: React.FC<ConfirmMigrationEntitiesDeletionModalProps> = ({
  open,
  entityKeys,
  confirmMigrationDeletionConfig,
  onClose,
  onConfirm,
}: ConfirmMigrationEntitiesDeletionModalProps) => {
  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      message={confirmMigrationDeletionConfig.title}
      statusColor="primary"
      buttonText="Confirm"
      maxWidth="35%"
    >
      <Alert variant="destructive" className="mt-3">
        <AlertTriangle />
        <AlertDescription>
          Each one's SharePoint folder is deleted too, with everything in it, including files NFS never uploaded. This
          can't be undone.
        </AlertDescription>
      </Alert>
      <div className="mt-4 flex flex-row flex-wrap items-center justify-center gap-2">
        {entityKeys.map((entityKey) => (
          <Badge
            key={entityKey}
            variant={JobEntityTypeColors[confirmMigrationDeletionConfig.jobEntityType]}
          >
            {entityKey}
          </Badge>
        ))}
      </div>
    </ConfirmationModal>
  );
};

export default ConfirmMigrationEntitiesDeletionModal;

export const CONFIRM_MIGRATION_ENTITIES_DELETION_CONFIGS = {
  CASES: {
    title: "Are you sure you want to delete cases?",
    jobEntityType: JobEntityType.Case,
  },

  INTAKES: {
    title: "Are you sure you want to delete intakes?",
    jobEntityType: JobEntityType.Intake,
  },

  PROVIDERS: {
    title: "Are you sure you want to delete providers?",
    jobEntityType: JobEntityType.Provider,
  },

  FIRM_DOCUMENTS_FOLDERS: {
    title: "Are you sure you want to delete firm documents folders?",
    jobEntityType: JobEntityType.FirmDocumentsFolder,
  },

  TEMPLATES_LIBRARIES: {
    title: "Are you sure you want to delete templates libraries?",
    jobEntityType: JobEntityType.TemplatesLibrary,
  },
} as const;
